import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

export default function BackButton({ text, link, children }: { text: string, link: string, children?: ReactNode }) {
    const navigate = useNavigate();

    return (
        <div className="mb-10">
            <button
                onClick={() => navigate(link)}
                className="flex cursor-pointer items-center text-accent font-semibold text-sm mb-4 hover:underline transition-all"
            >
                <ChevronLeft className="size-4 mr-1" />
                {text}
            </button>
            {children}
        </div>
    );
}
